






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Success extends Vue {
  
  @Prop({ default: 'Success!',  type: String}) label!: string;

}
